import type { MailboxInfo } from "owa-client-types";
import { copilotSettingsStore } from "owa-copilot-settings-store";
import { isAccountFeatureEnabled } from "owa-feature-flags";

export function isFrontierPublicUserEnabled(mailboxInfo: MailboxInfo): boolean {
    if (isAccountFeatureEnabled("mon-copilot-dev-frontier", mailboxInfo)) {
        return true;
    }
    
    const store = copilotSettingsStore(mailboxInfo);
    return (store.isFrontierPublicUser &&
        isAccountFeatureEnabled("mon-copilot-draft-frontier-public", mailboxInfo));
}
